import React from 'react';
import PropTypes from 'prop-types';
import Form from 'react-bootstrap/Form';

const ErrorMessage = ({ message }) => {
    return <Form.Control.Feedback type="invalid">{message}</Form.Control.Feedback>;
};

ErrorMessage.propTypes = {
    message: PropTypes.string.isRequired,
};

export default ErrorMessage;
